import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { BaasEdgePoolError } from '../../sections/types/BaasEdgePoolError';

export interface IGetDockerRegistryParams {
  clusterId: string;
}

export interface IGetDockerRegistryResult extends IResult {
  success?: {
    dockerRepository: string;
    loginName: string;
    password: string;
  };
  error?: BaasEdgePoolError;
}

export class GetDockerRegistryRequest extends Request<IGetDockerRegistryParams, IGetDockerRegistryResult> {
  constructor(params: IGetDockerRegistryParams) {
    super('getDockerRegistryInfo', params);
  }
}
